import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons';
import { select, Store } from '@ngrx/store';
import { itinerarySelectors, userSelectors } from '@app/core/ngrx/selectors';
import { State } from '@core/ngrx/reducers';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-nav-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FooterComponent implements OnInit {
    USER_ID: string; //
    USER_EMAIL: string; //
    USER_ID$ = this.store.select(userSelectors.getUserID);
    USER_EMAIL$ = this.store.select(userSelectors.getUserEmail);

    enableItineraries: boolean = false;

    constructor(
        private navCtrl: NavController,
        private store: Store<State>,
    ) {}

    itineraryList$ = this.store.select(itinerarySelectors.getItineraryList);

    faLayerGroup = faLayerGroup;
    itinerarySelections: any[] = [];

    ngOnInit() {
        this.USER_ID$.subscribe((userid: string) => (this.USER_ID = userid));
        this.USER_EMAIL$.subscribe(
            (useremail: string) => (this.USER_EMAIL = useremail)
        );

        this.itineraryList$.subscribe((itineraryList: any) => {
            this.itinerarySelections = itineraryList.map(
                (itineraryItem: any) => {
                    return { ...itineraryItem };
                }
            );

            if (this.itinerarySelections.length > 0) {
                this.enableItineraries = true;
            }
        });
    }

    switchPage(p: string): void {
        // if (window.location.href.includes('itinerary-create')) {
        //     this.toastService.presentFinalizeItineraryToast();
        // }
        this.navCtrl.navigateRoot(['/' + p]);
    }
}
